export { default as MaterialsIndexPageCategoriesNavAmountButton } from './MaterialsIndexPageCategoriesNavAmountButton';
